import { render, staticRenderFns } from "./SanjivaniInstructorIcard.vue?vue&type=template&id=e7408a00&scoped=true&"
import script from "./SanjivaniInstructorIcard.vue?vue&type=script&lang=js&"
export * from "./SanjivaniInstructorIcard.vue?vue&type=script&lang=js&"
import style0 from "./SanjivaniInstructorIcard.vue?vue&type=style&index=0&id=e7408a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7408a00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCol,VRadio,VRadioGroup,VRow})
